function mollyIsDesignMode() {
  return !!(window.Shopify && Shopify.designMode);
}

function logoSlider(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var sliders = scope.querySelectorAll
    ? scope.querySelectorAll('[data-image-slider], #custom-photo')
    : [];
  if (!sliders.length && scope.id === 'custom-photo') sliders = [scope];

  Array.prototype.forEach.call(sliders, function (el) {
    if (!el || el.nodeType !== 1) return;
    if (el.dataset.flickityBound === '1') return;

    // Theme editor: skip Flickity. wrapAround clones every cell and freezes Customize.
    if (mollyIsDesignMode()) {
      el.classList.add('spring-slider-visible', 'is-editor-simple');
      el.classList.remove('spring-slider-hidden');
      return;
    }

    if (typeof Flickity !== 'function') {
      el.classList.add('spring-slider-visible');
      return;
    }

    var cellCount = el.querySelectorAll('.custom-photo-item').length;
    if (!cellCount) {
      el.classList.add('spring-slider-visible');
      return;
    }
    el.dataset.flickityBound = '1';
    new Flickity(el, {
      wrapAround: cellCount > 2 && cellCount <= 16,
      fullscreen: true,
      contain: true,
      pageDots: false,
    });
    el.classList.add('spring-slider-visible');
  });
}

function scheduleLogoSlider(root) {
  var run = function () {
    logoSlider(root);
  };
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
  else run();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    scheduleLogoSlider(document);
  });
} else {
  scheduleLogoSlider(document);
}
if (mollyIsDesignMode()) {
  document.addEventListener('shopify:section:load', function (event) {
    scheduleLogoSlider(event.target);
  });
}



(function () {
  const hasDataYoutube = document.querySelector('[data-youtube]');
  if (hasDataYoutube) {
    const videos = document.querySelectorAll('[data-youtube]');
    for (let video of videos) {
      let id = new URL(video.href).searchParams.get('v');
      video.setAttribute('data-youtube', id);
      video.setAttribute('role', 'button');
      video.innerHTML =
        `<img srcset="https://img.youtube.com/vi/${id}/maxresdefault.jpg" loading="lazy"><img srcset="https://cdn.shopify.com/s/files/1/0753/0853/2013/files/youtube.png?v=1686745815" loading="lazy" class="youtub-ico"><br>
        ${video.textContent}`;
    }
    
    function clickHandler(event) {
      let link = event.target.closest('[data-youtube]');
      if (!link) return;
      event.preventDefault();
      let id = link.getAttribute('data-youtube');
      let player = document.createElement('div');
      player.innerHTML = `<div class="video-wrapper"><iframe src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
      link.replaceWith(player);
    }
    
    document.addEventListener('click', clickHandler);
  }
})();


/**
 * ------------------------------------------------------------------------------------------------------------
 * MOBILE INFINITE SCROLL / LOAD MORE (<load-more>)  — Dawn adaptation
 * ------------------------------------------------------------------------------------------------------------
 * Turns the list pages (collection / search / list-collections) into a "waterfall" on the mobile breakpoint
 * (<= 749px). Scrolling down to the bottom (finger swipe up) loads the next page: a spinner sits at the
 * bottom and the page cannot move until the response is in. With no further pages, the list stays as-is.
 *
 * On tablet & desktop this element stays inert — Dawn keeps its numbered pagination (also the SEO fallback,
 * rendered but hidden on phone via CSS).
 *
 * Rendered by snippets/pagination.liquid when `infinite: true`. Attributes:
 *   section-id, content-container, item-selector, total, count-template (LOADED_TOKEN), next-url.
 */
(function () {
  if (!document.getElementById('load-more-styles')) {
    var style = document.createElement('style');
    style.id = 'load-more-styles';
    style.textContent = [
      'load-more{display:none;}',
      '@media screen and (max-width:749px){',
      'load-more{display:flex;flex-direction:column;align-items:center;gap:1.2rem;margin:2rem 0 1rem;text-align:center;}',
      '.pagination-wrapper--infinite{display:none;}',
      '.load-more__button{display:none;}',
      '.load-more[data-load-error] .load-more__button{display:inline-flex;}',
      '}',
      '.load-more__count{margin:0;font-size:1.3rem;letter-spacing:.04rem;color:rgba(var(--color-foreground),.72);}',
      '.load-more__button{min-width:22rem;}',
      '.load-more__loading{display:none;align-items:center;justify-content:center;min-height:4.8rem;}',
      '.load-more__spinner{position:static;width:2.8rem;height:2.8rem;}',
      '.load-more__spinner .spinner{width:2.8rem;height:2.8rem;display:block;}',
      '.load-more[loading] .load-more__button{display:none;}',
      '.load-more[loading] .load-more__loading{display:flex;}',
      '.load-more__end{margin:.4rem 0 0;font-size:1.2rem;letter-spacing:.2rem;text-transform:uppercase;color:rgba(var(--color-foreground),.55);}',
      '.load-more__end[hidden]{display:none;}',
      'html.load-more-scroll-lock,html.load-more-scroll-lock body{overflow:hidden;overscroll-behavior:none;}',
      'html.load-more-scroll-lock body{position:fixed;width:100%;left:0;right:0;}'
    ].join('');
    document.head.appendChild(style);
  }

  var PHONE_QUERY = 'screen and (max-width: 749px)';

  window.customElements.define('load-more', class extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia(PHONE_QUERY);
      if (!this.mql.matches) return; // desktop/tablet: keep numbered pagination

      this.loading = false;
      this._nearBottom = false;
      this._scrolledDown = false;
      var renderedPage = Number(this.getAttribute('current-page') || '1');
      var urlPage = Number(new URLSearchParams(window.location.search).get('page') || '1');
      this._needsRestore = Math.max(renderedPage, urlPage) > 1;
      if (this._needsRestore) this.loading = true;
      this._scrollLocked = false;
      this._ignoreScroll = false;
      this._lastScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      this.button = this.querySelector('[data-load-more-button]');
      this.countElement = this.querySelector('[data-load-more-count]');
      this.endElement = this.querySelector('[data-load-more-end]');

      if (this.button) {
        this._onClick = this._loadNext.bind(this);
        this.button.addEventListener('click', this._onClick);
      }

      // 手指上滑（页面向下走）且已经到列表底部时才加载，避免一进页面就锁住
      this._onScroll = this._handleScroll.bind(this);
      this._onTouchStart = this._handleTouchStart.bind(this);
      this._onTouchMove = this._handleTouchMove.bind(this);
      this._onWheel = this._handleWheel.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      document.addEventListener('touchstart', this._onTouchStart, { passive: true });
      document.addEventListener('touchmove', this._onTouchMove, { passive: false });
      window.addEventListener('wheel', this._onWheel, { passive: false });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this._nearBottom = !!(entries[0] && entries[0].isIntersecting);
          this._maybeLoad();
        }, { rootMargin: '0px', threshold: 0 });
        this.observer.observe(this);
      }

      // bfcache 可能带回旧版逻辑已经重复插入的商品，恢复前先清理
      this._dedupeContainer();
      this._updateCount();
      // 服务端最后一页会直接写出结束文案。商品还没凑满时先藏起来，补齐后再决定
      if (this._isCollectionGrid() && this._loadedCount() < this._total()) this._hideEnd();
      if (this._needsRestore) this._restoreEarlierPages(renderedPage, urlPage);
      else {
        // 没有更早的页要补时，把当前页藏起来的末尾商品放回网格
        this._flushLiveHeld();
        this._updateCount();
        if (this._isCollectionGrid() && !this.nextUrl && this._loadedCount() < this._total()) this._fillToTotal(renderedPage);
      }

      // 返回时如果浏览器还原的是更早的 DOM，地址却还是 page=N，再把缺的页补上
      this._onPageShow = function (event) {
        if (!event.persisted) return;
        // 在请求锁滚动期间进入详情页时，bfcache 会连 body:fixed 一起保存
        var interrupted = this.loading || this._scrollLocked;
        this.loading = false;
        this.removeAttribute('loading');
        this._unlockScroll();
        this._dedupeContainer();
        this._updateCount();
        var shownPage = Number(new URLSearchParams(window.location.search).get('page') || '1');
        var currentPage = Number(this.getAttribute('current-page') || '1');
        // 结束态曾断开 observer；bfcache 回来后还有下一页时必须重新监听
        if (this.nextUrl) this._resumeLoading(this.nextUrl);
        if (shownPage > currentPage || (interrupted && shownPage > 1)) {
          this._restoreEarlierPages(currentPage, shownPage);
          return;
        }
        if (this._isCollectionGrid() && !this.nextUrl && this._loadedCount() < this._total()) this._fillToTotal(Math.max(currentPage, shownPage));
      }.bind(this);
      this._onPageHide = function () {
        // 离开列表页前先解锁，避免锁定样式被 bfcache 带到返回后的页面
        this._unlockScroll();
      }.bind(this);
      window.addEventListener('pageshow', this._onPageShow);
      window.addEventListener('pagehide', this._onPageHide);
    }

    /**
     * 瀑布流把地址换成 page=N 后，从详情返回会整页重载，服务端只输出第 N 页。
     * 按地址把第 1 页到第 N 页补齐，避免链接是 page=3、列表却只剩一页。
     */
    async _restoreEarlierPages(renderedPage, urlPage) {
      var pages = [];
      var page;
      for (page = 1; page < renderedPage; page += 1) pages.push(page);
      for (page = renderedPage + 1; page <= urlPage; page += 1) pages.push(page);
      if (!pages.length) {
        this.loading = false;
        this._rememberHistory(window.location.href);
        return;
      }

      this.setAttribute('loading', '');
      this._lockScroll();
      var loadedOk = false;
      this.loading = true;
      try {
        var liveContainer = this.container;
        var fetched = [];
        var index;
        for (index = 0; index < pages.length; index += 1) {
          fetched.push(await this._fetchPageGrid(pages[index]));
        }

        if (liveContainer) {
          var beforeHeight = liveContainer.offsetHeight;
          var earlier = [];
          var later = [];
          fetched.forEach(function (entry) {
            var bucket = entry.page < renderedPage ? earlier : later;
            bucket.push.apply(bucket, entry.items);
          });
          this._insertUnique(liveContainer, earlier, liveContainer.firstChild);
          this._insertUnique(liveContainer, later, null);
          // 当前页自己藏着的末尾商品，补页完成后再接到网格末尾
          this._flushLiveHeld();
          var addedHeight = Math.max(0, liveContainer.offsetHeight - beforeHeight);
          if (addedHeight && renderedPage > 1) this._lockedScrollY = (this._lockedScrollY || 0) + addedHeight;
        }

        var furthest = fetched.length ? fetched[fetched.length - 1] : null;
        if (urlPage > renderedPage && furthest) {
          this.setAttribute('current-page', String(urlPage));
          if (furthest.nextUrl) this._resumeLoading(furthest.nextUrl);
          else this.removeAttribute('next-url');
        }

        this._updateCount();
        // 补页之后如果仍短于总数，不能把结束文案留在页面上
        if (this._isCollectionGrid() && !this.nextUrl && this._loadedCount() < this._total()) {
          await this._fillToTotal(Math.max(renderedPage, urlPage));
        } else if (!this.nextUrl && this._loadedCount() >= this._total()) {
          this._showEnd();
        } else {
          this._hideEnd();
        }
        loadedOk = true;
      } catch (e) {
        if (window.console) console.warn(e);
      } finally {
        this.loading = false;
        this.removeAttribute('loading');
        this._unlockScroll();
        if (loadedOk) this._rememberHistory(window.location.href);
      }
    }

    _isCollectionGrid() {
      return this.getAttribute('content-container') === '#product-grid';
    }

    _total() {
      return Number(this.getAttribute('total') || '0');
    }

    /** 商品卡上的 handle。横幅没有，不计入 “Viewing x of total”。 */
    _handleOf(node) {
      if (!node || node.nodeType !== 1 || !node.querySelector) return '';
      var marked = node.querySelector('[data-product-handle]');
      if (marked) return marked.getAttribute('data-product-handle') || '';
      // 横幅也可能链接到商品页，只有商品卡内部链接才能作为 handle 兜底
      var card = node.querySelector('.card-wrapper, .card');
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      if (!link) return '';
      var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }

    _loadedCount() {
      var container = this.container;
      if (!container) return 0;
      if (!this._isCollectionGrid()) {
        var itemSelector = this.getAttribute('item-selector');
        if (itemSelector) return container.querySelectorAll(itemSelector).length;
        return container.children.length;
      }
      var count = 0;
      var seen = {};
      var self = this;
      Array.prototype.forEach.call(container.children, function (child) {
        var handle = self._handleOf(child);
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        count += 1;
      });
      return count;
    }

    _hideEnd() {
      if (this.endElement) this.endElement.hidden = true;
    }

    /** 恢复下一页地址时，同时恢复可能已经断开的底部监听。 */
    _resumeLoading(nextUrl) {
      if (!nextUrl) return;
      this.setAttribute('next-url', nextUrl);
      this._hideEnd();
      if (this.observer) this.observer.observe(this);
    }

    /** 只有商品数已经达到总数，才显示结束。 */
    _showEnd() {
      if (this._isCollectionGrid() && this._total() && this._loadedCount() < this._total()) {
        this._hideEnd();
        return;
      }
      this.removeAttribute('next-url');
      if (this.button) { this.button.remove(); this.button = null; }
      if (this.endElement) this.endElement.hidden = false;
      if (this.observer) this.observer.disconnect();
    }

    _markSeen(container) {
      var seen = {};
      var self = this;
      if (!container) return seen;
      Array.prototype.forEach.call(container.children, function (child) {
        var handle = self._handleOf(child);
        if (handle) seen[handle] = true;
      });
      return seen;
    }

    /** 返回缓存页时删除重复商品卡和重复横幅，避免数据、顺序和计数重复。 */
    _dedupeContainer() {
      var container = this.container;
      if (!container) return;
      var seenProducts = {};
      var seenPromos = {};
      var self = this;
      Array.prototype.forEach.call(container.children, function (child) {
        if (!child || child.nodeType !== 1) return;
        var handle = self._handleOf(child);
        if (handle) {
          if (seenProducts[handle]) child.remove();
          else seenProducts[handle] = true;
          return;
        }
        var promo = child.querySelector && child.querySelector('a[href]');
        var href = promo ? promo.getAttribute('href') : '';
        if (!href) return;
        if (seenPromos[href]) child.remove();
        else seenPromos[href] = true;
      });
    }

    /** 插进网格时按 handle 去重，横幅只保留一份。 */
    _insertUnique(container, nodes, before) {
      if (!container || !nodes || !nodes.length) return 0;
      var seen = this._markSeen(container);
      var fragment = document.createDocumentFragment();
      var added = 0;
      var self = this;
      nodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        var handle = self._handleOf(node);
        if (handle) {
          if (seen[handle]) return;
          seen[handle] = true;
        } else {
          var promo = node.querySelector && node.querySelector('a[href]');
          var href = promo ? promo.getAttribute('href') : '';
          if (href) {
            var exists = false;
            Array.prototype.forEach.call(container.querySelectorAll('a[href]'), function (link) {
              if (link.getAttribute('href') === href) exists = true;
            });
            if (exists) return;
          }
        }
        fragment.appendChild(node);
        added += 1;
      });
      if (!added) return 0;
      if (before) container.insertBefore(fragment, before);
      else container.appendChild(fragment);
      return added;
    }

    _decorateItem(child) {
      if (!child || child.nodeType !== 1) return;
      child.classList.remove('scroll-trigger');
      if (child.querySelectorAll) {
        Array.prototype.forEach.call(child.querySelectorAll('.scroll-trigger'), function (el) {
          el.classList.remove('scroll-trigger');
        });
      }
    }

    /** 当前页 HTML 里藏着的末尾商品，放回网格末尾。 */
    _flushLiveHeld() {
      if (!this._isCollectionGrid()) return;
      var held = document.getElementById('collection-held-products');
      if (!held || !held.content) return;
      var nodes = [];
      var self = this;
      Array.prototype.forEach.call(held.content.children, function (child) {
        self._decorateItem(child);
        if (child.nodeType === 1) nodes.push(child);
      });
      this._insertUnique(this.container, nodes, null);
    }

    /** 网格里的卡片，加上被挪到下一页开头的 held 商品。 */
    _itemsFromRoot(root) {
      var items = [];
      var self = this;
      var selector = this.getAttribute('content-container');
      var grid = selector ? root.querySelector(selector) : null;
      if (grid) {
        Array.prototype.forEach.call(grid.children, function (child) {
          self._decorateItem(child);
          if (child.nodeType === 1) items.push(child);
        });
      }
      var held = root.querySelector('#collection-held-products');
      if (held && held.content) {
        Array.prototype.forEach.call(held.content.children, function (child) {
          self._decorateItem(child);
          if (child.nodeType === 1) items.push(child);
        });
      }
      return items;
    }

    /**
     * 地址已经到某一页，但网格里的商品还没到 total。
     * 把 1..upTo 里缺的商品补上；这一页其实还有下一页时，把 next-url 接回去。
     */
    async _fillToTotal(upToPage) {
      if (!this._isCollectionGrid()) return;
      if (this._total() && this._loadedCount() >= this._total()) {
        this._showEnd();
        return;
      }
      // 从详情返回时可能没有外层锁，这里自己锁住，避免补页过程中继续滑动
      var lockedHere = false;
      if (!this._scrollLocked) {
        lockedHere = true;
        this.loading = true;
        this.setAttribute('loading', '');
        this._lockScroll();
      }
      this._hideEnd();
      try {
        var furthestNext = null;
        var page;
        for (page = 1; page <= upToPage; page += 1) {
          if (this._total() && this._loadedCount() >= this._total()) break;
          var entry = await this._fetchPageGrid(page);
          this._insertUnique(this.container, entry.items, null);
          if (page === upToPage) furthestNext = entry.nextUrl;
        }
        this._updateCount();
        if (this._total() && this._loadedCount() >= this._total()) {
          this._showEnd();
          return;
        }
        if (furthestNext) {
          this._resumeLoading(furthestNext);
          return;
        }
        this.removeAttribute('next-url');
        this._hideEnd();
      } finally {
        if (lockedHere) {
          this.loading = false;
          this.removeAttribute('loading');
          this._unlockScroll();
        }
      }
    }

    async _fetchPageGrid(page) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', this.getAttribute('section-id'));
      var response = await fetch(url.toString());
      if (!response.ok) throw new Error('load-more restore: ' + response.status);
      var fakeDiv = document.createElement('div');
      fakeDiv.innerHTML = await response.text();
      var loadMore = fakeDiv.querySelector('load-more');
      return {
        page: page,
        items: this._itemsFromRoot(fakeDiv),
        nextUrl: loadMore ? loadMore.getAttribute('next-url') : null
      };
    }

    /** 换地址时带上 searchParams，避免返回时筛选逻辑把列表刷回第一页。 */
    _rememberHistory(url) {
      try {
        var next = new URL(url, window.location.origin);
        var search = next.search.replace(/^\?/, '');
        history.replaceState({ searchParams: search, loadMore: true }, '', next.pathname + next.search + next.hash);
        if (window.FacetFiltersForm) FacetFiltersForm.searchParamsPrev = search;
      } catch (e) { /* ignore */ }
    }

    disconnectedCallback() {
      this._unlockScroll();
      if (this.observer) this.observer.disconnect();
      if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow);
      if (this._onPageHide) window.removeEventListener('pagehide', this._onPageHide);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onTouchStart) document.removeEventListener('touchstart', this._onTouchStart);
      if (this._onTouchMove) document.removeEventListener('touchmove', this._onTouchMove);
      if (this._onWheel) window.removeEventListener('wheel', this._onWheel);
      if (this.button && this._onClick) this.button.removeEventListener('click', this._onClick);
    }

    _handleScroll() {
      if (this.loading || this._scrollLocked || this._ignoreScroll) return;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y > this._lastScrollY + 1) {
        this._scrolledDown = true;
        // bfcache 可能保留已断开的 observer，滚到列表底部时直接用位置兜底
        this._nearBottom = this._nearBottom || this._nearLoadMore();
        this._maybeLoad();
      } else if (y < this._lastScrollY - 1) {
        this._scrolledDown = false;
      }
      this._lastScrollY = y;
    }

    _handleTouchStart(event) {
      if (!event.touches || !event.touches[0]) return;
      this._touchStartX = event.touches[0].clientX;
      this._touchStartY = event.touches[0].clientY;
    }

    /** 已经在底部时继续上滑，scroll 不会再变化，靠手势触发加载并拦住这次滑动。 */
    _handleTouchMove(event) {
      if (this.loading || this._scrollLocked || !this.nextUrl || !event.touches || !event.touches[0]) return;
      var dx = Math.abs(event.touches[0].clientX - (this._touchStartX || 0));
      var dy = (this._touchStartY || 0) - event.touches[0].clientY;
      if (dy < 12 || dx > dy) return;
      if (!this._nearLoadMore()) return;
      event.preventDefault();
      this._scrolledDown = true;
      this._nearBottom = true;
      this._maybeLoad();
    }

    _handleWheel(event) {
      if (this.loading || this._scrollLocked || !this.nextUrl || event.deltaY <= 0) return;
      if (!this._nearLoadMore()) return;
      event.preventDefault();
      this._scrolledDown = true;
      this._nearBottom = true;
      this._maybeLoad();
    }

    _nearLoadMore() {
      var rect = this.getBoundingClientRect();
      return rect.top <= window.innerHeight + 8;
    }

    /** 还有下一页、人已经滑到底，并且这次是在往下浏览，才开始加载。 */
    _maybeLoad() {
      if (this.loading || !this.nextUrl || !this._nearBottom) return;
      if (!this._scrolledDown && !this._fillShortPage) return;
      this._scrolledDown = false;
      this._fillShortPage = false;
      this._loadNext();
    }

    _lockScroll() {
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      this._lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = '-' + this._lockedScrollY + 'px';
      document.documentElement.classList.add('load-more-scroll-lock');
      this._preventMove = function (event) { event.preventDefault(); };
      document.addEventListener('touchmove', this._preventMove, { passive: false });
      document.addEventListener('wheel', this._preventMove, { passive: false });
    }

    _unlockScroll() {
      if (!this._scrollLocked) return;
      var y = this._lockedScrollY || 0;
      this._scrollLocked = false;
      this._ignoreScroll = true;
      document.documentElement.classList.remove('load-more-scroll-lock');
      document.body.style.top = '';
      if (this._preventMove) {
        document.removeEventListener('touchmove', this._preventMove);
        document.removeEventListener('wheel', this._preventMove);
        this._preventMove = null;
      }
      window.scrollTo(0, y);
      this._lastScrollY = y;
      var self = this;
      window.setTimeout(function () { self._ignoreScroll = false; }, 80);
    }

    get nextUrl() { return this.getAttribute('next-url'); }

    get container() {
      var selector = this.getAttribute('content-container');
      if (!selector) return null;
      // Scope to the surrounding grid container when present (Dawn wraps collection/search in
      // #ProductGridContainer); otherwise fall back to document (e.g. the list-collections page).
      var scope = this.closest('#ProductGridContainer') || document;
      return scope.querySelector(selector) || document.querySelector(selector);
    }

    _updateCount() {
      if (!this.countElement) return;
      var template = this.getAttribute('count-template');
      if (!template || !this.container) return;
      var loaded = this._loadedCount();
      this.countElement.textContent = template.replace('LOADED_TOKEN', loaded);
    }

    async _loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.setAttribute('loading', '');
      // 先把底部 loading 露出来，再冻住滚动，避免请求期间继续滑
      try { this.scrollIntoView({ block: 'end', inline: 'nearest' }); } catch (err) { /* ignore */ }
      this._lockScroll();
      var loadedOk = false;

      try {
        var fetchUrl = new URL(this.nextUrl, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.getAttribute('section-id'));

        var response = await fetch(fetchUrl.toString());
        if (!response.ok) throw new Error('load-more: ' + response.status);
        this.removeAttribute('data-load-error');
        var responseText = await response.text();

        var fakeDiv = document.createElement('div');
        fakeDiv.innerHTML = responseText;

        var liveContainer = this.container;
        // 非最后一页末尾的商品在 held 模板里，只追加网格会把它们丢掉
        if (liveContainer) this._insertUnique(liveContainer, this._itemsFromRoot(fakeDiv), null);

        this._rememberHistory(this.nextUrl);
        var loadedPage = Number(new URL(this.nextUrl, window.location.origin).searchParams.get('page') || '1');
        if (loadedPage) this.setAttribute('current-page', String(loadedPage));

        var newLoadMore = fakeDiv.querySelector('load-more');
        var newNextUrl = newLoadMore ? newLoadMore.getAttribute('next-url') : null;

        if (newNextUrl) {
          this._resumeLoading(newNextUrl);
        } else if (!this._isCollectionGrid() || this._loadedCount() >= this._total()) {
          this._showEnd();
        } else {
          // 这一页没有 next，但商品数还没到总数，不能当成已经结束
          await this._fillToTotal(loadedPage);
        }

        this._updateCount();
        loadedOk = true;
      } catch (e) {
        if (window.console) console.warn(e);
        this.setAttribute('data-load-error', '');
      } finally {
        this.loading = false;
        this.removeAttribute('loading');
        this._unlockScroll();
        // 这一页装不满屏幕时接着补，直到能滑动或没有下一页；失败不自动重试
        if (loadedOk && this.nextUrl && document.documentElement.scrollHeight <= window.innerHeight + 2) {
          this._fillShortPage = true;
          this._nearBottom = true;
          this._maybeLoad();
        }
      }
    }
  });
})();

/**
 * Collection cards use a stretched title link over the whole card.
 * If that overlay sits on top of the wishlist, click-through goes to the PDP.
 * Stop navigation on the wishlist hit area and toggle wishlist instead.
 */
(function () {
  var WISHLIST_SELECTOR = '.product-card-wrapper .product-card-wishlist, .product-card-wrapper .wishlist-button';

  function wishlistFromPoint(x, y) {
    var nodes = document.elementsFromPoint(x, y) || [];
    for (var i = 0; i < nodes.length; i++) {
      var match = nodes[i].closest && nodes[i].closest(WISHLIST_SELECTOR);
      if (match) return match;
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      // Let the wishlist app handle a direct hit; only intercept when the card link ate the click.
      if (event.target.closest(WISHLIST_SELECTOR)) return;
      if (!event.target.closest('.product-card-wrapper')) return;

      var wishlist = wishlistFromPoint(event.clientX, event.clientY);
      if (!wishlist) return;

      event.preventDefault();
      event.stopPropagation();

      var button = wishlist.matches && wishlist.matches('.wishlist-button')
        ? wishlist
        : wishlist.querySelector('.wishlist-button, .wc_wishlistBlock, button, [role="button"]');
      if (button) button.click();
    },
    true
  );
})();

(function () {
  function styleJudgeMeReviews() {
    document.querySelectorAll('.jdgm-rev-widg').forEach(function (widget) {
      var average = parseFloat(widget.getAttribute('data-average-rating') || '');
      var inner = widget.querySelector('.jdgm-rev-widg__summary-inner');
      var stars = widget.querySelector('.jdgm-rev-widg__summary-stars');
      var averageNode = widget.querySelector('.jdgm-rev-widg__summary-average');
      if (averageNode && !isNaN(average)) {
        averageNode.textContent = (Math.floor(average * 10) / 10).toFixed(1);
      }
      if (inner && stars && averageNode && averageNode.parentElement === stars) {
        inner.insertBefore(averageNode, stars);
      }
      var summaryText = inner && inner.querySelector('.jdgm-rev-widg__summary-text');
      if (inner && stars && summaryText && !inner.querySelector('.jdgm-rev-widg__summary-details')) {
        var details = document.createElement('div');
        details.className = 'jdgm-rev-widg__summary-details';
        inner.insertBefore(details, stars);
        details.appendChild(stars);
        details.appendChild(summaryText);
      }

      var writeLink = widget.querySelector('.jdgm-write-rev-link');
      if (writeLink) writeLink.style.setProperty('display', 'inline-flex', 'important');

      var histogram = widget.querySelector('.jdgm-histogram');
      if (histogram) histogram.classList.remove('jdgm-temp-hidden');

      widget.querySelectorAll('a').forEach(function (link) {
        var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (label === 'see all reviews' || label === 'see all review') {
          link.style.setProperty('display', 'none', 'important');
        }
      });

      var gallery = widget.querySelector('.jdgm-gallery');
      if (gallery) {
        var links = Array.prototype.slice.call(gallery.querySelectorAll('.jdgm-gallery__thumbnail-link')).filter(function (link) {
          var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          var img = link.querySelector('img.jdgm-gallery__thumbnail');
          if (!img || label === 'see more') {
            link.style.setProperty('display', 'none', 'important');
            return false;
          }
          var src = img.getAttribute('src') || img.getAttribute('data-src');
          if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
          var thumbWrap = img.closest('.jdgm-gallery__thumbnail-wrapper');
          if (thumbWrap) thumbWrap.classList.remove('jdgm--loading');
          return true;
        });
        links.forEach(function (link, index) {
          if (index >= 8) link.style.setProperty('display', 'none', 'important');
        });

        Array.prototype.slice.call(gallery.querySelectorAll('.jdgm-gallery__see-more')).forEach(function (node) {
          if (node.parentNode) node.parentNode.removeChild(node);
        });
      }

      widget.querySelectorAll('.jdgm-rev').forEach(function (review) {
        hydrateJudgeMeReviewMedia(review);
        Array.prototype.slice.call(review.querySelectorAll(
          '.jdgm-rev__icon, [class*="jdgm-rev__icon"], .jdgm-rev__reply, .jdgm-rev__buyer-badge-wrapper, .jdgm-rev__buyer-badge, .jdgm-rev__pinned, .jdgm-rev__author-img, .jdgm-rev__author-picture, .jdgm-row-profile img, .jdgm-rev__header > img'
        )).forEach(function (node) {
          if (node.parentNode) node.parentNode.removeChild(node);
        });

        var profile = review.querySelector('.jdgm-row-profile');
        var timestamp = review.querySelector('.jdgm-rev__timestamp');
        if (timestamp) {
          timestamp.classList.remove('jdgm-spinner');
          if (!timestamp.textContent.trim()) {
            var raw = timestamp.getAttribute('datetime') || timestamp.getAttribute('data-content') || '';
            var parsed = raw ? new Date(raw) : null;
            if (parsed && !isNaN(parsed.getTime())) {
              var month = String(parsed.getMonth() + 1).padStart(2, '0');
              var day = String(parsed.getDate()).padStart(2, '0');
              timestamp.textContent = month + '/' + day + '/' + parsed.getFullYear();
            }
          }
        }
        if (profile && timestamp && timestamp.parentElement !== profile) {
          profile.appendChild(timestamp);
        }

        var content = review.querySelector('.jdgm-rev__content');
        var rating = review.querySelector('.jdgm-rev__rating');
        var title = review.querySelector('.jdgm-rev__title');
        var body = review.querySelector('.jdgm-rev__body');
        var pics = review.querySelector('.jdgm-rev__pics');
        if (content && !content.querySelector('.jdgm-rev__main')) {
          var main = document.createElement('div');
          main.className = 'jdgm-rev__main';
          if (rating) main.appendChild(rating);
          if (title) main.appendChild(title);
          if (body) main.appendChild(body);
          if (pics) {
            content.insertBefore(main, pics);
          } else {
            content.insertBefore(main, content.firstChild);
          }
        }

        if (!pics || pics.querySelector('.jdgm-rev__pics-track')) return;

        var picLinks = Array.prototype.slice.call(pics.querySelectorAll('.jdgm-rev__pic-link'));

        if (picLinks.length < 2) return;

        var track = document.createElement('div');
        track.className = 'jdgm-rev__pics-track';
        picLinks.forEach(function (link) {
          track.appendChild(link);
        });

        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'jdgm-rev__pics-nav jdgm-rev__pics-nav--prev';
        prev.setAttribute('aria-label', 'Previous photos');

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'jdgm-rev__pics-nav jdgm-rev__pics-nav--next';
        next.setAttribute('aria-label', 'Next photos');

        pics.appendChild(prev);
        pics.appendChild(track);
        pics.appendChild(next);

        function updateNav() {
          var maxScroll = track.scrollWidth - track.clientWidth;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        }

        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          track.scrollBy({ left: -100, behavior: 'smooth' });
        });
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          track.scrollBy({ left: 100, behavior: 'smooth' });
        });
        track.addEventListener('scroll', updateNav);
        updateNav();
      });

      setupJudgeMeShowMore(widget);
    });
  }

  var JUDGE_ME_PAGE_SIZE = 5;

  function hydrateJudgeMeReviewMedia(review) {
    review.classList.add('jdgm--done-setup');
    Array.prototype.forEach.call(review.querySelectorAll('.jdgm-rev__pic-link'), function (link) {
      var img = link.querySelector('img.jdgm-rev__pic-img, img');
      if (img) {
        var src = img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
        img.classList.remove('jdgm--loading');
      }
      link.classList.remove('jdgm--loading');
    });
  }

  function getJudgeMeReviewKey(review) {
    return review.getAttribute('data-review-id') ||
      review.getAttribute('data-id') ||
      review.id ||
      (review.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function getJudgeMeVisibleCount(widget) {
    return parseInt(widget.getAttribute('data-jdgm-visible-count') || String(JUDGE_ME_PAGE_SIZE), 10) || JUDGE_ME_PAGE_SIZE;
  }

  function getJudgeMeTotalReviews(widget) {
    var host = widget.closest('.jdgm-review-widget') || widget;
    var total = parseInt(
      host.getAttribute('data-number-of-reviews') ||
      widget.getAttribute('data-number-of-reviews') ||
      '0',
      10
    );
    return isNaN(total) ? 0 : total;
  }

  function setupJudgeMeShowMore(widget) {
    var paginate = widget.querySelector('.jdgm-paginate');
    var list = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!paginate || !list) return;

    var totalPages = 1;
    var lastPage = paginate.querySelector('.jdgm-paginate__last-page');
    if (lastPage) {
      totalPages = parseInt(lastPage.getAttribute('data-page') || '1', 10) || 1;
    }

    var toggle = widget.querySelector('.jdgm-show-more-toggle');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'jdgm-show-more-toggle';
      toggle.innerHTML = '<span class="jdgm-show-more-toggle__label">Show more</span>';
      paginate.appendChild(toggle);
    }

    var reviewCount = list.querySelectorAll('.jdgm-rev').length;
    if (reviewCount <= JUDGE_ME_PAGE_SIZE && totalPages <= 1 && widget.getAttribute('data-jdgm-show-more-ready') !== '1') {
      toggle.style.display = 'none';
      return;
    }

    if (!widget.getAttribute('data-jdgm-visible-count')) {
      widget.setAttribute('data-jdgm-visible-count', String(JUDGE_ME_PAGE_SIZE));
    }
    if (!widget.getAttribute('data-jdgm-next-page')) {
      widget.setAttribute('data-jdgm-next-page', String(Math.max(2, Math.floor(reviewCount / JUDGE_ME_PAGE_SIZE) + 1)));
    }
    widget.setAttribute('data-jdgm-total-pages', String(totalPages));

    if (toggle.getAttribute('data-jdgm-bound') !== '1') {
      toggle.setAttribute('data-jdgm-bound', '1');
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (toggle.disabled) return;

        var currentVisible = getJudgeMeVisibleCount(widget);
        var targetVisible = currentVisible + JUDGE_ME_PAGE_SIZE;
        var existing = list.querySelectorAll('.jdgm-rev').length;

        function revealNextPage() {
          var loaded = list.querySelectorAll('.jdgm-rev').length;
          widget.setAttribute('data-jdgm-visible-count', String(Math.min(targetVisible, loaded)));
          applyJudgeMeReviewLimit(widget, toggle);
        }

        if (existing >= targetVisible || widget.getAttribute('data-jdgm-reviews-complete') === '1') {
          revealNextPage();
          return;
        }

        toggle.disabled = true;
        loadJudgeMeReviewPages(widget, list, targetVisible).then(function () {
          toggle.disabled = false;
          revealNextPage();
          styleJudgeMeReviews();
          setTimeout(styleJudgeMeReviews, 50);
          setTimeout(styleJudgeMeReviews, 400);
        }).catch(function () {
          toggle.disabled = false;
          applyJudgeMeReviewLimit(widget, toggle);
        });
      });
    }

    widget.setAttribute('data-jdgm-show-more-ready', '1');
    applyJudgeMeReviewLimit(widget, toggle);
  }

  function applyJudgeMeReviewLimit(widget, toggle) {
    var visible = getJudgeMeVisibleCount(widget);
    var reviews = widget.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev');
    reviews.forEach(function (review, index) {
      review.classList.toggle('jdgm-rev--collapsed', index >= visible);
    });
    if (!toggle) return;

    var label = toggle.querySelector('.jdgm-show-more-toggle__label');
    if (label) label.textContent = 'Show more';
    toggle.classList.remove('is-expanded');

    var total = getJudgeMeTotalReviews(widget);
    var complete = widget.getAttribute('data-jdgm-reviews-complete') === '1';
    var hasMoreInDom = reviews.length > visible;
    var totalPages = parseInt(widget.getAttribute('data-jdgm-total-pages') || '1', 10) || 1;
    var nextPage = parseInt(widget.getAttribute('data-jdgm-next-page') || '2', 10) || 2;
    var hasMorePages = !complete && nextPage <= totalPages;

    if ((total > 0 && visible >= total) || (!hasMoreInDom && !hasMorePages)) {
      toggle.style.display = 'none';
    } else {
      toggle.style.display = '';
    }
  }

  function loadJudgeMeReviewPages(widget, list, neededCount) {
    var host = widget.closest('.jdgm-review-widget') || widget.closest('[data-id]') || document.querySelector('.jdgm-review-widget');
    var productId =
      (host && (host.getAttribute('data-product-id') || host.getAttribute('data-id'))) ||
      widget.getAttribute('data-product-id') ||
      widget.getAttribute('data-id');
    var shop = window.jdgm && typeof window.jdgm.shopDomain === 'function' ? window.jdgm.shopDomain() : '';
    var apiHost = (window.jdgm && window.jdgm.API_HOST) || 'https://api.judge.me';
    if (!productId || !shop) return Promise.reject();

    var totalPages = parseInt(widget.getAttribute('data-jdgm-total-pages') || '1', 10) || 1;
    var fetches = 0;
    var maxFetches = 8;

    function existingKeys() {
      var keys = {};
      Array.prototype.forEach.call(list.querySelectorAll('.jdgm-rev'), function (review) {
        keys[getJudgeMeReviewKey(review)] = true;
      });
      return keys;
    }

    function fetchPage(page) {
      var params = new URLSearchParams({
        url: shop,
        shop_domain: shop,
        platform: 'shopify',
        page: String(page),
        per_page: String(JUDGE_ME_PAGE_SIZE),
        product_id: productId
      });

      return fetch(apiHost + '/reviews/reviews_for_widget?' + params.toString())
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.html) return { added: 0, received: 0 };
          var temp = document.createElement('div');
          temp.innerHTML = data.html;
          var incoming = temp.querySelector('.jdgm-rev-widg__reviews') || temp;
          var reviews = incoming.querySelectorAll('.jdgm-rev');
          var keys = existingKeys();
          var added = 0;
          Array.prototype.forEach.call(reviews, function (review) {
            var key = getJudgeMeReviewKey(review);
            if (!key || keys[key]) return;
            keys[key] = true;
            hydrateJudgeMeReviewMedia(review);
            list.appendChild(review);
            added += 1;
          });
          return { added: added, received: reviews.length };
        });
    }

    function step() {
      if (list.querySelectorAll('.jdgm-rev').length >= neededCount) {
        return Promise.resolve();
      }
      if (widget.getAttribute('data-jdgm-reviews-complete') === '1') {
        return Promise.resolve();
      }

      var nextPage = parseInt(widget.getAttribute('data-jdgm-next-page') || '2', 10) || 2;
      if (nextPage > totalPages || fetches >= maxFetches) {
        widget.setAttribute('data-jdgm-reviews-complete', '1');
        return Promise.resolve();
      }

      fetches += 1;
      return fetchPage(nextPage).then(function (result) {
        widget.setAttribute('data-jdgm-next-page', String(nextPage + 1));
        if (result.received < JUDGE_ME_PAGE_SIZE || nextPage + 1 > totalPages) {
          widget.setAttribute('data-jdgm-reviews-complete', '1');
        }
        return step();
      });
    }

    return step();
  }

  if (mollyIsDesignMode()) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleJudgeMeReviews);
  } else {
    styleJudgeMeReviews();
  }
  document.addEventListener('jdgm.doneSetup', styleJudgeMeReviews);
  window.addEventListener('load', styleJudgeMeReviews);
  setTimeout(styleJudgeMeReviews, 1200);
})();

/* Overlay wishlist：WC 按钮保持透明，未收藏/已收藏图标由容器伪元素绘制 */
(function () {
  var ROOT =
    '.product__media-wrapper .product-media__wishlist, .product-card-wrapper .product-card-wishlist';
  var painting = false;

  document.addEventListener(
    'click',
    function (event) {
      var root = event.target.closest && event.target.closest('.product__media-wrapper .product-media__wishlist');
      if (!root) return;
      var button = root.querySelector('.wc_wishlistBlock, button, [role="button"]');
      if (!button) return;
      if (button === event.target || button.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      button.click();
    },
    true
  );

  function isFavorited(button) {
    if (!button) return false;
    var label = (button.getAttribute('aria-label') || '').toLowerCase();
    var title = (button.getAttribute('title') || '').toLowerCase();
    return (
      button.classList.contains('isActive') ||
      button.classList.contains('wc_wishlisted') ||
      button.classList.contains('active') ||
      button.classList.contains('added') ||
      button.classList.contains('wishlisted') ||
      label.indexOf('remove') !== -1 ||
      title.indexOf('remove') !== -1
    );
  }

  function paintWishlist(root) {
    var favorited = false;
    var nodes = root.querySelectorAll('.wc_wishlistBlock, button, [role="button"]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (isFavorited(node)) favorited = true;
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('background-color', 'transparent', 'important');
    });
    root.classList.toggle('is-wishlisted', favorited);
  }

  function paintAll() {
    if (painting) return;
    painting = true;
    document.querySelectorAll(ROOT).forEach(function (root) {
      paintWishlist(root);
      if (mollyIsDesignMode()) return;
      if (root.dataset.wlPaintBound || typeof MutationObserver === 'undefined') return;
      root.dataset.wlPaintBound = '1';
      var observer = new MutationObserver(function () {
        paintWishlist(root);
      });
      observer.observe(root, {
        attributes: true,
        attributeFilter: ['class', 'aria-label'],
        childList: true,
        subtree: true,
      });
    });
    painting = false;
  }

  var paintTimer = null;
  function schedulePaintAll() {
    if (paintTimer) return;
    paintTimer = window.setTimeout(function () {
      paintTimer = null;
      paintAll();
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', paintAll);
  window.addEventListener('load', paintAll);
  window.setTimeout(paintAll, 200);

  if (mollyIsDesignMode()) return;

  window.setTimeout(paintAll, 800);
  window.setTimeout(paintAll, 1600);

  if (typeof MutationObserver !== 'undefined') {
    var docObserver = new MutationObserver(schedulePaintAll);
    docObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/**
 * Product card image placeholder: keep the MOLLYEVERS plate visible until the
 * main image has actually downloaded (including infinite-scroll cards and swatch swaps).
 */
(function () {
  var MEDIA_SELECTOR = '.product-card-wrapper .card__media';
  var IMAGE_SELECTOR = '.product-card-wrapper .card__media .media > img.product-card-image';
  var SECONDARY_SELECTOR = '.product-card-wrapper .card__media .media.media--hover-effect > img.product-card-image + img';

  function setLoaded(media, loaded) {
    if (!media) return;
    media.classList.toggle('is-image-loaded', loaded);
  }

  function markSecondary(img) {
    var media = img && img.closest(MEDIA_SELECTOR);
    if (media && img.naturalWidth > 0) media.classList.add('is-secondary-loaded');
  }

  function primeSecondary(img) {
    if (!img) return;
    if (img.loading === 'lazy') img.loading = 'eager';
    if (img.complete) markSecondary(img);
  }

  function bindSecondary(img) {
    if (!img || img.dataset.cardSecondaryBind === '1') return;
    img.dataset.cardSecondaryBind = '1';
    img.addEventListener('load', function () {
      markSecondary(img);
    });
    if (img.complete) markSecondary(img);
  }

  function watchMedia(media) {
    if (!media || media.dataset.cardHoverBind === '1') return;
    media.dataset.cardHoverBind = '1';
    media.addEventListener('pointerenter', function () {
      primeSecondary(media.querySelector('.media > img.product-card-image + img'));
    });
  }

  function bindImage(img) {
    if (!img || img.dataset.cardImageBind === '1') return;
    img.dataset.cardImageBind = '1';
    var media = img.closest(MEDIA_SELECTOR);
    if (!media) return;

    img.addEventListener('load', function () {
      if (img.naturalWidth > 0) setLoaded(media, true);
    });
    img.addEventListener('error', function () {
      setLoaded(media, false);
    });

    if (img.complete && img.naturalWidth > 0) {
      setLoaded(media, true);
    }
  }

  function bindAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll(IMAGE_SELECTOR);
    for (var i = 0; i < images.length; i++) bindImage(images[i]);
    var secondaryImages = scope.querySelectorAll(SECONDARY_SELECTOR);
    for (var j = 0; j < secondaryImages.length; j++) bindSecondary(secondaryImages[j]);
    var medias = scope.querySelectorAll ? scope.querySelectorAll(MEDIA_SELECTOR) : [];
    if (scope.matches && scope.matches(MEDIA_SELECTOR)) watchMedia(scope);
    for (var k = 0; k < medias.length; k++) watchMedia(medias[k]);
  }

  bindAll(document);

  document.addEventListener(
    'load',
    function (event) {
      var img = event.target;
      if (!img || img.tagName !== 'IMG' || !img.classList.contains('product-card-image')) return;
      var media = img.closest(MEDIA_SELECTOR);
      if (media && img.naturalWidth > 0) setLoaded(media, true);
    },
    true
  );

  if (mollyIsDesignMode()) return;

  if (typeof MutationObserver === 'function' && document.body) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(IMAGE_SELECTOR)) bindImage(node);
          if (node.matches && node.matches(SECONDARY_SELECTOR)) bindSecondary(node);
          if (!node.matches || (!node.matches(IMAGE_SELECTOR) && !node.matches(SECONDARY_SELECTOR))) bindAll(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

/* Footer signup: 把勾选的 Event role 写进 customer tags */
(function () {
  function syncFooterSignupTags(form) {
    if (!form) return;
    var hidden = form.querySelector('[data-footer-signup-tags]');
    if (!hidden) return;
    var roles = [];
    var boxes = form.querySelectorAll('[data-footer-signup-role]:checked');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.value) roles.push(box.value);
    });
    hidden.value = ['newsletter'].concat(roles).join(', ');
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-footer-signup-role]')) return;
    syncFooterSignupTags(event.target.closest('[data-footer-signup]'));
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-footer-signup]')) return;
    syncFooterSignupTags(event.target);
  });
})();

/* 导航标题：把数学粗体还原成普通字母，Hot 文案与 Figma 一致 */
(function () {
  function normalizeNodeText(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      node.nodeValue = node.nodeValue.normalize('NFKC');
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.classList && node.classList.contains('hed-hot')) {
      node.textContent = 'Hot';
      return;
    }
    Array.prototype.forEach.call(node.childNodes, normalizeNodeText);
  }

  function normalizeHeaderNav() {
    var items = document.querySelectorAll('.header__inline-menu > .list-menu--inline > li, .announcement-bar__message');
    Array.prototype.forEach.call(items, function (item) {
      normalizeNodeText(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeHeaderNav);
  } else {
    normalizeHeaderNav();
  }
})();

/* PDP Extra 10% OFF：有原价时显示叠加后的最终折扣（$20 / $14.99 → $13.49 = 33% off） */
(function () {
  var VERSION = 8;
  if (window.__mollyPdpExtraOffVersion === VERSION) return;
  if (typeof window.__mollyPdpExtraOffCleanup === 'function') {
    window.__mollyPdpExtraOffCleanup();
  }
  window.__mollyPdpExtraOffVersion = VERSION;

  try {
    sessionStorage.removeItem('mollyPdpExtraOff');
  } catch (e) {}

  var EXTRA_OFF_PROPERTY = '_extra_off';
  var animating = false;
  var restoring = false;
  var mutating = false;
  var extraOffApplied = false;
  var extraOffAppliedOnProductId = '';
  var lastActiveRoot = null;
  var observer = null;
  var variantSubscribed = false;
  var cartSyncing = false;

  function extraOffRoot(fromEl) {
    if (fromEl && fromEl.closest) {
      var info = fromEl.closest('product-info');
      if (info) {
        lastActiveRoot = info;
        return info;
      }
      var modal = fromEl.closest('quick-add-modal');
      if (modal) {
        info = modal.querySelector('product-info');
        if (info) {
          lastActiveRoot = info;
          return info;
        }
      }
    }
    if (lastActiveRoot && document.contains(lastActiveRoot)) return lastActiveRoot;
    var openModal = document.querySelector('quick-add-modal[open] product-info');
    if (openModal) return openModal;
    return document.querySelector('product-info') || document;
  }

  function extraOffBtn(root) {
    return extraOffRoot(root).querySelector('.product-pdp-extra-off');
  }

  function extraOffPercent(root) {
    var btn = extraOffBtn(root);
    var percent = btn ? parseFloat(btn.getAttribute('data-discount-percent')) : 10;
    if (isNaN(percent) || percent <= 0 || percent >= 100) percent = 10;
    return percent;
  }

  function getDiscountCode(root) {
    var btn = extraOffBtn(root);
    return (btn && btn.getAttribute('data-discount-code')) || 'TOP10';
  }

  /* 与 Shopify 折扣码一致：折扣金额向下取整。$14.99 × 10% → $13.50 */
  function extraOffSaleCents(fromCents, root) {
    var discountCents = Math.floor((fromCents * extraOffPercent(root)) / 100);
    return Math.max(0, fromCents - discountCents);
  }

  function currentProductId(root) {
    var btn = extraOffBtn(root);
    if (btn && btn.getAttribute('data-product-id')) return String(btn.getAttribute('data-product-id'));
    var info = extraOffRoot(root);
    if (info && info.getAttribute && info.getAttribute('data-product-id')) {
      return String(info.getAttribute('data-product-id'));
    }
    return '';
  }

  function productInfosFor(root) {
    var id = currentProductId(root);
    if (id) {
      return Array.prototype.slice.call(document.querySelectorAll('product-info[data-product-id="' + id + '"]'));
    }
    var single = extraOffRoot(root);
    return single ? [single] : [];
  }

  function setFormExtraOffProperty(on, root) {
    var infos = productInfosFor(root);
    var forms = [];
    infos.forEach(function (info) {
      Array.prototype.push.apply(forms, info.querySelectorAll('form[data-type="add-to-cart-form"]'));
    });
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[name="properties[' + EXTRA_OFF_PROPERTY + ']"]');
      if (on) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + EXTRA_OFF_PROPERTY + ']';
          form.appendChild(input);
        }
        input.value = '1';
      } else if (input) {
        input.parentNode.removeChild(input);
      }
    });
  }

  function priceWrap(root) {
    return extraOffRoot(root).querySelector('.product-pdp-price');
  }

  function clearAppliedUi(root) {
    extraOffApplied = false;
    extraOffAppliedOnProductId = '';
    setFormExtraOffProperty(false, root);
    productInfosFor(root).forEach(function (info) {
      var wrap = info.querySelector('.product-pdp-price');
      if (wrap) {
        wrap.classList.remove('is-extra-off');
        wrap.removeAttribute('data-extra-off-applied');
      }
      var extraOff = info.querySelector('.product-pdp-extra-off');
      if (!extraOff) return;
      extraOff.classList.remove('is-applied');
      var action = extraOff.querySelector('.product-pdp-extra-off__action');
      if (action) action.textContent = 'Tap to apply';
    });
  }

  function isApplied(root) {
    var productId = currentProductId(root);
    if (!extraOffApplied || !extraOffAppliedOnProductId) return false;
    if (productId && extraOffAppliedOnProductId !== productId) {
      clearAppliedUi(root);
      return false;
    }
    return true;
  }

  function getPdpPriceEl(root) {
    var wrap = priceWrap(root);
    if (!wrap) return null;
    var price = wrap.querySelector('.price');
    if (price && price.classList.contains('price--on-sale')) {
      return price.querySelector('.price__sale .price-item--sale');
    }
    return wrap.querySelector('.price__regular .price-item--regular');
  }

  function parsePriceCents(el) {
    if (!el) return NaN;
    var attr = parseInt(el.getAttribute('data-price-cents'), 10);
    if (!isNaN(attr) && attr > 0) return attr;
    var text = (el.textContent || '').replace(/[^\d.]/g, '');
    if (!text) return NaN;
    return Math.round(parseFloat(text) * 100);
  }

  function getCompareCents(root) {
    var compareEl = root && root.querySelector('.price--on-sale .price__sale s.price-item--regular');
    if (!compareEl) return NaN;
    var attr = parseInt(compareEl.getAttribute('data-compare-cents'), 10);
    if (!isNaN(attr) && attr > 0) return attr;
    var digits = (compareEl.textContent || '').replace(/[^\d.]/g, '');
    if (!digits) return NaN;
    return Math.round(parseFloat(digits) * 100);
  }

  function formatPdpMoney(cents, sampleText) {
    var symbol = (sampleText || '$').replace(/[\d.,\s]/g, '') || '$';
    var value = Math.abs(cents) / 100;
    if (cents % 100 !== 0 || /\.\d/.test(sampleText || '')) {
      return symbol + value.toFixed(2);
    }
    return symbol + String(Math.round(value));
  }

  function settlePrice(el, cents, sampleText) {
    mutating = true;
    var text = formatPdpMoney(cents, sampleText);
    el.classList.remove('price-roll');
    el.removeAttribute('aria-label');
    el.textContent = text;
    el.setAttribute('data-price-cents', String(cents));
    el.setAttribute('data-extra-off', '1');
    mutating = false;
  }

  /* 有原价：$20 → $13.49 显示 (33% off)；无原价仍显示 Extra 10% */
  function updateOffNote(finalSaleCents, root) {
    var wrap = priceWrap(root);
    if (!wrap || isNaN(finalSaleCents) || finalSaleCents <= 0) return;
    var compareCents = getCompareCents(wrap);
    var percent;
    if (!isNaN(compareCents) && compareCents > finalSaleCents) {
      percent = Math.round(((compareCents - finalSaleCents) / compareCents) * 100);
    } else {
      percent = extraOffPercent(root);
    }
    var text = '(' + percent + '% off)';
    mutating = true;
    Array.prototype.forEach.call(wrap.querySelectorAll('.price-item-off'), function (note) {
      if (note.textContent !== text) note.textContent = text;
    });
    mutating = false;
  }

  function animatePriceRoll(el, fromCents, toCents, sampleText, root) {
    animating = true;
    var fromVal = Math.round(fromCents / 100);
    var toVal = Math.round(toCents / 100);
    if (fromVal === toVal) {
      settlePrice(el, toCents, sampleText);
      updateOffNote(toCents, root);
      animating = false;
      return;
    }

    var delta = Math.abs(fromVal - toVal);
    var cycles = Math.ceil(delta / 10) + 3;
    var startCycle = cycles - 2;
    var totalItems = cycles * 10;
    var symbol = formatPdpMoney(fromCents, sampleText).replace(/[\d.,\s]/g, '') || '$';
    var digitCount = String(Math.max(fromVal, toVal)).length;
    var html = '<span class="price-roll__char" aria-hidden="true">' + symbol + '</span>';
    var places = [];
    var i;
    var n;
    var c;

    for (i = 0; i < digitCount; i++) {
      var place = Math.pow(10, digitCount - 1 - i);
      var fromDigit = Math.floor(fromVal / place) % 10;
      var startIndex = startCycle * 10 + fromDigit;
      places.push({ place: place, startIndex: startIndex });
      html +=
        '<span class="price-roll__digit" aria-hidden="true"><span class="price-roll__reel" style="transform:translateY(-' +
        (startIndex * 100) / totalItems +
        '%)">';
      for (c = 0; c < cycles; c++) {
        for (n = 0; n < 10; n++) html += '<span>' + n + '</span>';
      }
      html += '</span></span>';
    }

    mutating = true;
    el.classList.add('price-roll');
    el.innerHTML = html;
    el.setAttribute('aria-label', formatPdpMoney(fromCents, sampleText));
    mutating = false;

    var reels = el.querySelectorAll('.price-roll__reel');
    var duration = Math.max(800, Math.min(1600, delta * 90));
    var start = performance.now();

    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var current = fromVal + (toVal - fromVal) * eased;
      var ticks = fromVal - current;
      for (i = 0; i < reels.length; i++) {
        var index = places[i].startIndex - ticks / places[i].place;
        reels[i].style.transform = 'translateY(-' + (index * 100) / totalItems + '%)';
      }
      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        settlePrice(el, toCents, sampleText);
        updateOffNote(toCents, root);
        animating = false;
      }
    }

    requestAnimationFrame(tick);
  }

  function applyExtraOffToPrice(animate, root) {
    var clicked = extraOffRoot(root);
    productInfosFor(clicked).forEach(function (info) {
      var priceEl = getPdpPriceEl(info);
      if (!priceEl) return;
      if (priceEl.getAttribute('data-extra-off') === '1') {
        updateOffNote(parsePriceCents(priceEl), info);
        return;
      }
      var fromCents = parsePriceCents(priceEl);
      if (isNaN(fromCents) || fromCents <= 0) return;
      var sample = (priceEl.textContent || '$').replace(/\s+/g, ' ').trim() || '$';
      var toCents = extraOffSaleCents(fromCents, info);
      priceEl.setAttribute('data-extra-off', '1');
      updateOffNote(toCents, info);
      if (animate && info === clicked) {
        animatePriceRoll(priceEl, fromCents, toCents, sample, info);
      } else {
        settlePrice(priceEl, toCents, sample);
      }
    });
  }

  function cartUpdateUrl() {
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update';
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function fetchCartSections(sectionIds) {
    var ids = sectionIds || ['cart-drawer', 'cart-icon-bubble'];
    var sections = {};
    return Promise.all(
      ids.map(function (id) {
        return fetch(cartUrl() + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
          .then(function (res) {
            return res.text();
          })
          .then(function (html) {
            sections[id] = html;
          });
      })
    ).then(function () {
      return sections;
    });
  }

  function applyDiscountToCart() {
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: getDiscountCode() }),
    }).then(function (res) {
      return res.json();
    });
  }

  function replaceCartDrawerSections(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections) return;
    var parsed = { sections: sections };
    drawer.getSectionsToRender().forEach(function (section) {
      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement || !sections[section.id]) return;
      sectionElement.innerHTML = drawer.getSectionInnerHTML(sections[section.id], section.selector);
    });
    if (drawer.querySelector('#CartDrawer-Overlay')) {
      drawer.querySelector('#CartDrawer-Overlay').addEventListener('click', drawer.close.bind(drawer));
    }
    return parsed;
  }

  function syncCartDiscount(options) {
    if (!isApplied()) return Promise.resolve(null);
    if (cartSyncing) return Promise.resolve(null);
    cartSyncing = true;
    var silent = !!(options && options.silent);
    return applyDiscountToCart()
      .then(function () {
        return fetchCartSections(['cart-drawer', 'cart-icon-bubble']);
      })
      .then(function (sections) {
        var parsed = { sections: sections };
        if (silent) replaceCartDrawerSections(sections);
        return parsed;
      })
      .catch(function (err) {
        console.error(err);
        return null;
      })
      .then(function (parsed) {
        cartSyncing = false;
        return parsed;
      });
  }

  function markApplied(root) {
    extraOffApplied = true;
    extraOffAppliedOnProductId = currentProductId(root);
    lastActiveRoot = extraOffRoot(root);
    setFormExtraOffProperty(true, root);
    productInfosFor(root).forEach(function (info) {
      var wrap = info.querySelector('.product-pdp-price');
      var extraOff = info.querySelector('.product-pdp-extra-off');
      if (wrap) {
        wrap.classList.add('is-extra-off');
        wrap.setAttribute('data-extra-off-applied', '1');
      }
      if (!extraOff) return;
      extraOff.classList.add('is-applied');
      var action = extraOff.querySelector('.product-pdp-extra-off__action');
      if (action) action.textContent = 'Applied';
    });
  }

  function restoreIfNeeded(root) {
    if (!isApplied(root) || animating || restoring || mutating) return;
    restoring = true;
    markApplied(root);
    applyExtraOffToPrice(false, root);
    restoring = false;
  }

  function hasExtraOffProperty(item) {
    var props = item && item.properties;
    if (!props) return false;
    return props._extra_off === '1' || props['_extra_off'] === '1';
  }

  function cartNeedsCheckoutDiscount(cart) {
    if (isApplied()) return true;
    if (!cart || !cart.items) return false;
    var i;
    for (i = 0; i < cart.items.length; i++) {
      if (hasExtraOffProperty(cart.items[i])) return true;
    }
    var codes = cart.discount_codes || [];
    for (i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].applicable) return true;
    }
    return false;
  }

  function checkoutWithDiscount(code) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    if (root.charAt(root.length - 1) !== '/') root += '/';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  function submitNativeCheckout(btn) {
    var form =
      btn.form ||
      btn.closest('form') ||
      document.getElementById('CartDrawer-Form') ||
      document.getElementById('cart');
    if (!form) {
      window.location.href = '/checkout';
      return;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '1';
    form.appendChild(input);
    form.submit();
  }

  /* 需要尺码但这一行没有 Size 时，Checkout 不能继续 */
  function cartSizeScope(control) {
    if (control && control.closest) {
      var drawer = control.closest('cart-drawer');
      if (drawer) return drawer;
    }
    return document.getElementById('main-cart-items') || document;
  }

  function shakeCartSizeNotice(el) {
    if (!el) return;
    el.hidden = false;
    el.classList.remove('is-shaking');
    void el.offsetWidth;
    el.classList.add('is-shaking');
  }

  function checkoutSizeNotice(control) {
    if (!control || !control.closest) return null;
    var host = control.closest('.cart__ctas, .cart__dynamic-checkout-buttons');
    var parent = host && host.parentNode;
    if (!parent) return null;
    var notice = parent.querySelector('[data-cart-checkout-size-notice]');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'molly-cart-checkout-size-notice';
      notice.setAttribute('data-cart-checkout-size-notice', '');
      notice.setAttribute('role', 'alert');
      notice.hidden = true;
      notice.textContent = 'Please select a size before checkout.';
      parent.insertBefore(notice, host);
    }
    return notice;
  }

  function blockCheckoutWithoutSize(control) {
    var scope = cartSizeScope(control);
    var items = scope.querySelectorAll ? scope.querySelectorAll('.cart-item[data-size-missing="1"]') : [];
    var notice = checkoutSizeNotice(control);
    if (!items.length) {
      if (notice) notice.hidden = true;
      return false;
    }
    var firstAlert = null;
    Array.prototype.forEach.call(items, function (item) {
      item.classList.add('is-size-missing');
      var alert = item.querySelector('[data-cart-size-alert]');
      if (!alert) return;
      shakeCartSizeNotice(alert);
      if (!firstAlert) firstAlert = alert;
    });
    shakeCartSizeNotice(notice);
    var scrollTarget = firstAlert || items[0];
    if (scrollTarget && scrollTarget.scrollIntoView) {
      scrollTarget.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return true;
  }

  function onCartCheckoutSubmit(e) {
    var form = e.target;
    if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
    var submitter = e.submitter;
    if (submitter && submitter.name && submitter.name !== 'checkout') return;
    var control = submitter || form.querySelector('[name="checkout"]') || form;
    if (!blockCheckoutWithoutSize(control)) return;
    e.preventDefault();
    e.stopPropagation();
  }

  function onCheckoutClick(e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], .cart__checkout-button');
    /* 只拦购物车里的快捷支付，不影响详情页 Buy it now */
    var walletHost =
      !btn &&
      e.target.closest &&
      e.target.closest('.cart__dynamic-checkout-buttons, shopify-accelerated-checkout-cart');
    var wallet = walletHost && walletHost.closest('cart-drawer, #main-cart-footer') ? walletHost : null;
    var control = btn || wallet;
    if (!control) return;
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    if (blockCheckoutWithoutSize(control)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!btn) return;
    if (btn.getAttribute('data-molly-checkout') === '1') return;
    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('data-molly-checkout', '1');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cartNeedsCheckoutDiscount(cart)) {
          submitNativeCheckout(btn);
          return null;
        }
        return applyDiscountToCart().then(function () {
          checkoutWithDiscount(getDiscountCode());
        });
      })
      .catch(function () {
        btn.removeAttribute('data-molly-checkout');
        submitNativeCheckout(btn);
      });
  }

  function onExtraOffClick(e) {
    var extraOff = e.target.closest && e.target.closest('.product-pdp-extra-off');
    if (!extraOff) return;
    var code = extraOff.getAttribute('data-discount-code') || 'TOP10';
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code);
    }
    if (!isApplied(extraOff) && !animating) {
      markApplied(extraOff);
      applyExtraOffToPrice(true, extraOff);
      bindObserver();
      syncCartDiscount({ silent: true });
    }
  }

  function onVariantChange() {
    bindObserver();
    if (!isApplied()) return;
    requestAnimationFrame(restoreIfNeeded);
    window.setTimeout(restoreIfNeeded, 80);
  }

  function bindVariantRestore() {
    if (variantSubscribed) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      variantSubscribed = true;
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  function bindObserver() {
    if (mollyIsDesignMode()) return;
    if (typeof MutationObserver === 'undefined') return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function (mutations) {
      if (!isApplied() || animating || restoring || mutating) return;
      var i;
      for (i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        var wrap = target && target.closest ? target.closest('.product-pdp-price') : null;
        var root = wrap ? extraOffRoot(wrap) : extraOffRoot();
        var priceEl = getPdpPriceEl(root);
        if (priceEl && priceEl.getAttribute('data-extra-off') === '1') continue;
        restoreIfNeeded(root);
        return;
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.product-pdp-price'), function (wrap) {
      observer.observe(wrap, { childList: true, subtree: true });
    });
  }

  function onSectionLoad() {
    bindObserver();
    if (!isApplied()) return;
    restoreIfNeeded();
  }

  function onReady() {
    bindObserver();
    bindVariantRestore();
  }

  window.__mollyPdpExtraOffApi = {
    isApplied: isApplied,
    syncCartDiscount: function () {
      return syncCartDiscount();
    },
  };

  window.__mollyPdpExtraOffCleanup = function () {
    document.removeEventListener('click', onExtraOffClick);
    document.removeEventListener('click', onCheckoutClick, true);
    document.removeEventListener('submit', onCartCheckoutSubmit, true);
    document.removeEventListener('DOMContentLoaded', onReady);
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('product-info:loaded', onSectionLoad);
    if (observer) observer.disconnect();
    observer = null;
    if (window.__mollyPdpExtraOffApi) delete window.__mollyPdpExtraOffApi;
  };

  document.addEventListener('click', onExtraOffClick);
  document.addEventListener('click', onCheckoutClick, true);
  document.addEventListener('submit', onCartCheckoutSubmit, true);
  bindObserver();
  bindVariantRestore();
  document.addEventListener('DOMContentLoaded', onReady);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('product-info:loaded', onSectionLoad);
})();

/* Remember last PDP size on this device. New visitors get no size selected. */
(function () {
  var STORAGE_KEY = 'mollyevers:lastPdpSize';

  function sizeRoot(scope) {
    var area = scope && scope.querySelector ? scope : document;
    return area.querySelector('.size_options');
  }

  function buyControlScope(el) {
    if (!el || !el.closest) return document;
    return el.closest('quick-add-modal') || el.closest('product-info') || document;
  }

  function isCardQuickAddControl(btn) {
    if (!btn) return false;
    if (btn.classList && btn.classList.contains('quick-add__submit')) return true;
    return !!(btn.closest && btn.closest('.quick-add, modal-opener[data-modal^="#QuickAdd"]'));
  }

  function sizeLabel(item) {
    if (!item) return '';
    var div = item.querySelector('label > div');
    if (!div) return '';
    var clone = div.cloneNode(true);
    var badges = clone.querySelectorAll('.producty-suxc-free');
    for (var i = 0; i < badges.length; i++) badges[i].parentNode.removeChild(badges[i]);
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function readSavedSize() {
    try {
      return localStorage.getItem(STORAGE_KEY) || '';
    } catch (err) {
      return '';
    }
  }

  function writeSavedSize(label) {
    if (!label) return;
    try {
      localStorage.setItem(STORAGE_KEY, label);
    } catch (err) {}
  }

  function hasCheckedSize(root) {
    return !!(root && root.querySelector('input[name="properties[Size]"]:checked'));
  }

  function isActuallySoldOut(submit) {
    if (!submit) return false;
    if (submit.classList.contains('is-sold-out')) return true;
    var label = (submit.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return label.indexOf('sold out') !== -1;
  }

  function applyItemUi(item) {
    if (!item) return;
    var input = item.querySelector('input[type="radio"]');
    if (input) input.checked = true;

    var label = sizeLabel(item);
    document.querySelectorAll('.data-size-value').forEach(function (el) {
      el.textContent = label;
    });

    var siblings = item.parentNode ? item.parentNode.children : [];
    var offset = siblings[0] && siblings[0].classList.contains('single_item-custom') ? 1 : 0;
    var chartIndex = item.classList.contains('single_item-custom')
      ? -1
      : Array.prototype.indexOf.call(siblings, item) - offset;
    document.querySelectorAll('.row-scroll tbody > tr').forEach(function (tr, i) {
      tr.classList.toggle('active', i === chartIndex);
    });
    document.querySelectorAll('.row-scroll .row-scroll-content').forEach(function (row, i) {
      row.classList.toggle('active', i === chartIndex);
    });
    syncSizeChart(chartIndex >= 0);

    if (window.jQuery) window.jQuery(item).triggerHandler('click');
    hideSizeInlineHint();
    syncSizeErrorBanner();
  }

  function isStandardSizeChecked() {
    return !!document.querySelector('.single_item-size input:checked');
  }

  function syncSizeChart(visible) {
    document.querySelectorAll('.row-scroll').forEach(function (el) {
      el.classList.toggle('is-visible', !!visible);
    });
  }

  function restoreSavedSize() {
    var root = sizeRoot();
    if (!root) return false;
    var saved = readSavedSize();
    if (!saved) return false;
    var items = root.querySelectorAll('.single_item');
    var match = null;
    for (var i = 0; i < items.length; i++) {
      if (sizeLabel(items[i]) === saved) {
        match = items[i];
        break;
      }
    }
    if (!match) return false;
    applyItemUi(match);
    return true;
  }

  function onSizeChange(event) {
    var input = event.target;
    if (!input || input.name !== 'properties[Size]') return;
    var item = input.closest('.single_item');
    if (!item) return;
    writeSavedSize(sizeLabel(item));
    hideSizeInlineHint();
    syncSizeChart(item.classList.contains('single_item-size'));
    syncSizeErrorBanner();
  }

  function isCustomSizeChecked() {
    return !!document.querySelector('.single_item-custom input:checked');
  }

  var inlineHintTimer = null;

  function sizeInlineHint(scope) {
    var area = scope && scope.querySelector ? scope : document;
    return area.querySelector('[data-size-inline-hint]');
  }

  function hideSizeInlineHint(scope) {
    var hint = sizeInlineHint(scope);
    if (hint) {
      hint.hidden = true;
      hint.classList.remove('is-shaking');
    }
    if (inlineHintTimer) {
      window.clearTimeout(inlineHintTimer);
      inlineHintTimer = null;
    }
  }

  function showSizeInlineHint(scope) {
    var hint = sizeInlineHint(scope);
    if (!hint) return;
    hint.hidden = false;
    hint.classList.remove('is-shaking');
    void hint.offsetWidth;
    hint.classList.add('is-shaking');
    if (inlineHintTimer) window.clearTimeout(inlineHintTimer);
    inlineHintTimer = window.setTimeout(hideSizeInlineHint, 3000);
  }

  function sizeErrorBanner() {
    return document.querySelector('[data-size-error-banner]');
  }

  function syncSizeErrorBanner() {
    var banner = sizeErrorBanner();
    if (!banner) return;
    banner.hidden = true;
    banner.classList.remove('is-shaking');
  }

  function setMobileSizeError(on, scope) {
    if (!on) {
      hideSizeInlineHint(scope);
      return;
    }
    showSizeInlineHint(scope);
  }

  function scrollToSize(scope) {
    var area = scope && scope.querySelector ? scope : document;
    var target = area.querySelector('.product-size-legend, .size_options');
    if (target && target.scrollIntoView) target.scrollIntoView({ block: 'center' });
  }

  function shouldBlockBuyWithoutSize(scope) {
    var area = scope && scope.querySelector ? scope : document;
    var submit = area.querySelector('.product-form__submit');
    if (isActuallySoldOut(submit)) return false;
    var root = sizeRoot(area);
    return !!(root && !hasCheckedSize(root));
  }

  /* Shopify may hide the unbranded fallback while PayPal loads; keep one visible button. */
  function ensureWalletVisible() {
    if (mollyIsDesignMode()) return;
    if (isCustomSizeChecked()) return;
    document.querySelectorAll('.shopify-payment-button').forEach(function (wrap) {
      wrap.style.removeProperty('display');
      var accelerated = wrap.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
      var branded = wrap.querySelector(
        '.shopify-payment-button__button--branded, iframe[name*="paypal" i], iframe[title*="PayPal" i], iframe[title*="Apple Pay" i]'
      );
      var unbranded = wrap.querySelector('.shopify-payment-button__button--unbranded');
      if ((accelerated && accelerated.childElementCount) || branded) {
        if (unbranded) unbranded.classList.add('shopify-payment-button__button--hidden');
        return;
      }
      var visibleBtn = wrap.querySelector(
        '.shopify-payment-button__button:not(.shopify-payment-button__button--hidden)'
      );
      if (visibleBtn) return;
      if (unbranded) unbranded.classList.remove('shopify-payment-button__button--hidden');
    });
  }

  function ensureSizeHint(parent, extraClass) {
    if (!parent) return null;
    var hint = parent.querySelector(':scope > .molly-size-hint');
    if (!hint) {
      hint = document.createElement('span');
      hint.className = 'molly-size-hint' + (extraClass ? ' ' + extraClass : '');
      hint.setAttribute('aria-hidden', 'true');
      parent.appendChild(hint);
    }
    hint.textContent = 'Please select a size';
    return hint;
  }

  function bindHintHover() {
    var buttons = document.querySelector('product-info .product-form__buttons');
    if (!buttons || buttons.dataset.sizeHintBound === '1') return;
    buttons.dataset.sizeHintBound = '1';
    buttons.addEventListener('pointerover', function (event) {
      if (!buttons.classList.contains('is-size-required')) {
        buttons.classList.remove('is-hint-atc', 'is-hint-wallet');
        return;
      }
      var wallet = event.target.closest('.shopify-payment-button, .molly-wallet-size-guard');
      var atc = event.target.closest('.product-form__submit, [name="add"]');
      buttons.classList.toggle('is-hint-atc', !!atc && !wallet);
      buttons.classList.toggle('is-hint-wallet', !!wallet);
    });
    buttons.addEventListener('pointerleave', function () {
      buttons.classList.remove('is-hint-atc', 'is-hint-wallet');
    });
  }

  function syncWalletGuard() {
    var buttons = document.querySelector('product-info .product-form__buttons');
    var needsSize = shouldBlockBuyWithoutSize();
    if (buttons) {
      buttons.classList.toggle('is-size-required', needsSize);
      if (!needsSize) buttons.classList.remove('is-hint-atc', 'is-hint-wallet');
      ensureSizeHint(buttons);
      bindHintHover();
    }

    document.querySelectorAll('.shopify-payment-button').forEach(function (wrap) {
      var guard = wrap.querySelector('.molly-wallet-size-guard');
      if (!needsSize || isCustomSizeChecked()) {
        if (guard) guard.hidden = true;
        return;
      }
      if (!guard) {
        guard = document.createElement('button');
        guard.type = 'button';
        guard.className = 'molly-wallet-size-guard';
        guard.setAttribute('aria-label', 'Please select a size');
        wrap.appendChild(guard);
      }
      guard.hidden = false;
    });
  }

  function onAddWithoutSize(event) {
    var btn =
      event.target.closest &&
      event.target.closest(
        '.product-form__submit, [name="add"], .shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button, .molly-wallet-size-guard'
      );
    if (!btn) return;
    /* 推荐/相关商品 Choose options 会带 name="add"，不能按主商品尺码拦截 */
    if (isCardQuickAddControl(btn)) return;
    if (btn.matches && btn.matches('.product-form__submit, [name="add"]') && isActuallySoldOut(btn)) return;
    var scope = buyControlScope(btn);
    if (!shouldBlockBuyWithoutSize(scope)) return;
    event.preventDefault();
    event.stopPropagation();
    scrollToSize(scope);
    setMobileSizeError(true, scope);
  }

  function init() {
    restoreSavedSize();
    syncSizeChart(isStandardSizeChecked());
    syncSizeErrorBanner();
    ensureWalletVisible();
    syncWalletGuard();
  }

  document.addEventListener('change', function (event) {
    onSizeChange(event);
    ensureWalletVisible();
    syncWalletGuard();
  });
  document.addEventListener('click', onAddWithoutSize, true);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
  window.addEventListener('load', function () {
    ensureWalletVisible();
    syncWalletGuard();
  });
  setTimeout(function () {
    ensureWalletVisible();
    syncWalletGuard();
  }, 800);

  if (mollyIsDesignMode()) return;

  if (typeof MutationObserver !== 'undefined') {
    var walletTimer = null;
    var walletObserver = new MutationObserver(function () {
      if (walletTimer) return;
      walletTimer = window.setTimeout(function () {
        walletTimer = null;
        ensureWalletVisible();
      }, 80);
    });
    document.querySelectorAll('product-info .shopify-payment-button').forEach(function (wrap) {
      walletObserver.observe(wrap, { childList: true, subtree: true });
    });
  }
})();

/**
 * 首页商品轮播：不自动播放。左右按钮一直显示，每次只滑一张。
 * 到头的按钮变淡且不可点。手机端 is-overflowing 时第三张露出约 10%。
 */
(function () {
  if (window.customElements.get('product-carousel')) return;

  var ProductCarousel = class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-product-carousel-viewport]');
      this.prevButton = this.querySelector('[data-product-carousel-prev]');
      this.nextButton = this.querySelector('[data-product-carousel-next]');
      this.stage = this.querySelector('.product-carousel__stage');
      if (!this.viewport || !this.prevButton || !this.nextButton) return;

      this._onScroll = this._syncControls.bind(this);
      this._onResize = this._update.bind(this);
      this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
      this.prevButton.addEventListener('click', (this._onPrev = this._prev.bind(this)));
      this.nextButton.addEventListener('click', (this._onNext = this._next.bind(this)));
      window.addEventListener('resize', this._onResize);

      if (typeof ResizeObserver === 'function') {
        this._observer = new ResizeObserver(this._onResize);
        this._observer.observe(this);
      }

      this.querySelectorAll('img').forEach(
        function (img) {
          if (!img.complete) img.addEventListener('load', this._onResize, { once: true });
        }.bind(this)
      );

      this._update();
    }

    disconnectedCallback() {
      if (this.viewport && this._onScroll) this.viewport.removeEventListener('scroll', this._onScroll);
      if (this.prevButton && this._onPrev) this.prevButton.removeEventListener('click', this._onPrev);
      if (this.nextButton && this._onNext) this.nextButton.removeEventListener('click', this._onNext);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._observer) this._observer.disconnect();
    }

    _items() {
      return Array.from(this.viewport.querySelectorAll('[data-product-carousel-item]'));
    }

    _perRow() {
      var styles = getComputedStyle(this);
      var desktop = parseFloat(styles.getPropertyValue('--pc-per-row-desktop')) || 5;
      var mobile = parseFloat(styles.getPropertyValue('--pc-per-row-mobile')) || 2;

      if (window.matchMedia('(min-width: 1000px)').matches) return desktop;
      if (window.matchMedia('(min-width: 741px)').matches) return 3;
      return mobile;
    }

    _prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    _prev() {
      this._move(-1);
    }

    _next() {
      this._move(1);
    }

    /** 找到相对当前滚动位置的上一张 / 下一张，只移动一格。 */
    _move(direction) {
      var items = this._items();
      var current = this.viewport.scrollLeft;
      var target = null;
      var index;

      if (direction > 0) {
        target = items.find(function (item) {
          return item.offsetLeft > current + 4;
        });
      } else {
        for (index = items.length - 1; index >= 0; index -= 1) {
          if (items[index].offsetLeft < current - 4) {
            target = items[index];
            break;
          }
        }
      }

      if (!target) return;

      this.viewport.scrollTo({
        left: target.offsetLeft,
        behavior: this._prefersReducedMotion() ? 'auto' : 'smooth',
      });
    }

    _update() {
      var count = this._items().length;
      this.classList.toggle('is-overflowing', count > this._perRow());
      this._positionArrows();
      this._syncControls();
    }

    /** 箭头垂直居中在商品图上，而不是整张卡片（图 + 标题 + 价格）。 */
    _positionArrows() {
      var image = this.querySelector('.card__media');
      if (!image || !this.stage) return;

      var stageTop = this.stage.getBoundingClientRect().top;
      var imageRect = image.getBoundingClientRect();
      var center = imageRect.top - stageTop + imageRect.height / 2;
      if (center > 0) this.stage.style.setProperty('--pc-arrow-top', center + 'px');
    }

    _syncControls() {
      var max = this.viewport.scrollWidth - this.viewport.clientWidth;
      var left = Math.abs(this.viewport.scrollLeft);
      var canScroll = max > 2;

      this.prevButton.hidden = false;
      this.nextButton.hidden = false;
      this.prevButton.disabled = !canScroll || left <= 2;
      this.nextButton.disabled = !canScroll || left >= max - 2;
    }
  };

  window.customElements.define('product-carousel', ProductCarousel);
})();

/* 移动端 Klaviyo 礼品卡入口：竖排文案会挡住关闭按钮，且样式会取消官方隐藏。 */
(function () {
  function dismissKlaviyoTeaser(event) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('button[aria-label="Close teaser"]');
    if (!button) return;

    var teaser = button.closest('[class*="kl-teaser-"]');
    if (!teaser) return;

    event.preventDefault();
    event.stopPropagation();
    teaser.classList.add('mollyevers-kl-teaser-dismissed');
  }

  document.addEventListener('click', dismissKlaviyoTeaser, true);
  document.addEventListener('touchend', dismissKlaviyoTeaser, true);
})();
